import React from 'react'
import { connect } from 'react-redux'
import { FormattedHTMLMessage, injectIntl } from 'react-intl'
import FormattedMessage from '../../../components/FormattedMessage/FormattedMessage'
import ClaimNavigation from '../../../components/ClaimNavigation/ClaimNavigation'
import CheckInput from '../../../components/Input/CheckInput/CheckInput'
import ImageUrlUtil from '../../../utilities/boxImageUrlFormatter'
import { claimActions } from '../../../redux/actions'

import './Confirm.scss'

class Confirm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      eulaText: 'page.redemptionPage.text.acceptanceDisclaimer',
      confirm: 'checked',
    }
  }

  _buildActiveContentImageSrc = imageUrl => ImageUrlUtil(imageUrl)

  _renderPromotionStep = promotion =>
    promotion.selectedContent.map(content => (
      <div
        key={`selected-content-${content.contentId}`}
        className="row d-flex justify-content-center my-3"
      >
        <div className="col-md-6 col-lg-5 my-3">
          <div className="row">
            <div className="col-12 d-flex justify-content-center">
              <img
                src={this._buildActiveContentImageSrc(content.imageUrl)}
                alt={`${content.content.name} box art`}
                className="confirm-img-container"
              />
            </div>
          </div>
        </div>
        <div className="col-md-6 col-lg-7 my-3">
          <h4 id={`content-heading-${content.contentId}`}>{content.content.name}</h4>
          <p>{content.content.description}</p>
          <div className="d-flex flex-wrap">
            {content.content.contentRatings.map((ratings, index) => (
              <div key={ratings.rating.id} className="d-flex">
                <img
                  src={ratings.rating.fileName}
                  key={ratings.rating.name}
                  alt={ratings.rating.name}
                  className={`mb-3 img-fluid contentItem-page__ratingImg ${
                    index === 0 ? 'mr-1' : 'mx-1'
                  }`}
                />
              </div>
            ))}
          </div>
          <div>
            <p className="content-attribute m-0">{content.legalAttributeTitle}</p>
            <p className="content-attribute m-0">{content.legalAttributeDescription}</p>
            <p className="content-attribute m-0">
              <span dangerouslySetInnerHTML={{ __html: content.legalAttributeUrl }} />
            </p>
            <p className="content-attribute m-0">
              <FormattedMessage
                id={`contentProvider.${content.content.content_provider.name}.legalAttribute.title`}
              />
            </p>
            <p className="content-attribute m-0">
              <FormattedMessage
                id={`contentProvider.${content.content.content_provider.name}.legalAttribute.description`}
              />
            </p>
            <p className="content-attribute m-0">
              <FormattedHTMLMessage
                id={`contentProvider.${content.content.content_provider.name}.legalAttribute.url`}
              />
            </p>
          </div>
        </div>
      </div>
    ))

  // eslint-disable-next-line react/destructuring-assignment
  _renderSelectedContent = () =>
    this.props.claim.selectedContentList.map(promotion => (
      <div key={`promotion-step-${promotion.promotionStepId}`}>
        {this._renderPromotionStep(promotion)}
        {promotion.selectedContent.length ? <div className="hr my-3" /> : ''}
      </div>
    ))

  render() {
    const { eulaText } = this.state
    const {
      claim: { currentPromotion, confirm },
      toggleConfirm,
    } = this.props

    return (
      <div aria-labelledby="confirm-current-promotion-heading">
        <h4 id="confirm-current-promotion-heading">{currentPromotion.name}</h4>
        <div className="row">
          <div className="col">
            <p>
              <FormattedMessage id="page.redemptionPage.text.confirmSelection" />
            </p>
          </div>
        </div>
        {this._renderSelectedContent()}
        <CheckInput
          containerClass="redeem-games-eula-text mb-5"
          name="accept"
          checked={confirm}
          label={eulaText}
          onChange={() => {
            toggleConfirm()
          }}
        />
        <ClaimNavigation />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  claim: state.claimReducers,
})

const mapDispatchToProps = dispatch => ({
  toggleConfirm: () => dispatch(claimActions.toggleConfirm()),
})

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(Confirm))
